import {
  initTracerError,
  initTracerErrorAsyncStack,
  initTracerErrorUploader,
  initTracerLog,
  initTracerSessionUploader,
  initTracerWebVitals,
  initTracerWebVitalsUploader,
} from '@tracer/sdk';
// TODO он тут временно, если поможет с ошибками, то вынести отдельно
// сейчас прописан тут, тк этот код пихается в бандл максимально рано
import 'web-streams-polyfill/polyfill';

import filterError from './filterError';
import './polyfills';
import writeConsoleToLog from './writeConsoleToLog';

const isValidHost = window.location.host === 'www.rustore.ru';

if (isValidHost) {
  const config = {
    versionName: process.env.TRACER_VERSION_NAME,
    versionCode: Number.parseInt(process.env.TRACER_VERSION_CODE),
    appToken: process.env.TRACER_APP_TOKEN,
  };

  const tracer = initTracerError({filterError});

  tracer.setErrorKeys({
    pathname: window.location.pathname,
    query: window.location.search,
  });

  initTracerErrorUploader(config);
  initTracerSessionUploader(config);

  initTracerWebVitals({
    addMetricAttributes: () => ({pathname: location.pathname}),
  });

  initTracerWebVitalsUploader(config);

  initTracerErrorAsyncStack();

  if (typeof window._tracer_module === 'string') {
    tracer.setModule(window._tracer_module);
  }

  const logger = initTracerLog();

  writeConsoleToLog(logger);
}
